import { useMutation, useQueryClient } from '@tanstack/react-query';
import { calendarConnectionsService } from '../api/calendar-connections.service';
import { CALENDAR_CONNECTIONS_KEYS } from './queryKeys';
import type { UpdateLinkedCalendarPayload } from '../types';

interface UpdateLinkedCalendarVariables {
  connectionId: string;
  calendarId: string;
  payload: UpdateLinkedCalendarPayload;
}

/** Updates scope / tenant / sync toggle / color of a linked calendar. */
export function useUpdateLinkedCalendar() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ connectionId, calendarId, payload }: UpdateLinkedCalendarVariables) =>
      calendarConnectionsService.updateLinkedCalendar(connectionId, calendarId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CALENDAR_CONNECTIONS_KEYS.all });
    },
  });
}
